import * as actions from '../actionTypes';
import { GET_TUITION_VALUES, ADD_TUITION_VALUES, UPDATE_TUITION_VALUES } from '../api';
import client from '../apolloClient';

export const getTuitionValues = () => async (dispatch) => {
    try {
        const { data } = await client.query({
            query: GET_TUITION_VALUES,
        });
        const tuitionValues = data.tuitionValues;
        const action = { type: actions.SET_TUITION_VALUES, payload: tuitionValues };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const addTuitionValues = (input) => async (dispatch, getState) => {
    try {
        const { data } = await client.mutate({
            mutation: ADD_TUITION_VALUES,
            variables: { input },
        });
        const addedTuitionValue = data.addTuitionValues;
        const action = { type: actions.ADD_TUITION_VALUES, payload: addedTuitionValue };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const updateTuitionValues = (input) => async (dispatch, getState) => {
    try {
        const { data } = await client.mutate({
            mutation: UPDATE_TUITION_VALUES,
            variables: { input },
        });
        const updatedTuitionValues = data.updateTuitionValues;
        const action = { type: actions.UPDATE_TUITION_VALUES, payload: updatedTuitionValues };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
